import {
    Grid,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
} from '@mui/material';


export function CheckboxToggle({ label, options, state, setState }) {
    return (
        <FormControl component="fieldset" variant="standard" sx={{ mt: 2 }}>
            <FormLabel>{label}</FormLabel>
            <FormGroup>
                <Grid container>
                    {options.map(({ key, label }, index) => (
                        <Grid size={12} key={index}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={state[key]}
                                        onChange={(e) =>
                                            setState((prev) => ({ ...prev, [key]: e.target.checked }))
                                        }
                                    />
                                }
                                label={label}
                            />
                        </Grid>
                    ))}
                </Grid>
            </FormGroup>
        </FormControl>
    )
};